import { useNavigate, useRouter } from '@tanstack/react-router';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { useAuthentication } from '@src/context/hooks';
import { useMountEffect, useTimeout } from '@src/corelib/hooks';


function Logout() {
  const router = useRouter();
  const navigate = useNavigate();
  const auth = useAuthentication();

  const timeout = useTimeout();

  const logout = () => {
    return new Promise((resolve) => {
      timeout.set(
        'logout',
        () => {
          auth.logout().then(() => {
            router.invalidate().finally(() => {
              navigate({ to: '/auth/login' });
              resolve();
            });
          });
        },
        500,
      );
    });
  };

  useMountEffect(() => {
    logout();
  });

  return (<Box sx={StyleSheet.root}><CircularProgress /></Box>);
}

const StyleSheet = {
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

Logout.displayName = 'Logout';
export default Logout;
